<template>
  <div id="app">
    <div v-if="$store.state.appInfo.site_state == 1">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />
      <div class="loading_popup" v-if="loading" style="display: block">
        <div>
          <div></div>
          <div>加载中...</div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">{{ $store.state.appInfo.repair_tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      loading: false,
      daoTime: null,
      tanshow: true,
    };
  },
  created() {
    let that = this;
    if (sessionStorage.getItem('token')) {
      that.openDaoTime();
      that.getUserInfo();
    }
    console.log('版本代码更新时间 2022-10-13 18:14');
    var query = that.$route.query;
    if (query.pid) {
      localStorage.setItem('pid', query.pid);

      this.$router.push({ path: `login?type=1&pid=${query.pid}` });
    }
    that.getApp();
    that.getVisitUrl();
  },
  methods: {
    getVisitUrl() {
      let that = this;
      var query = that.$route.query;

      that.$apiFun
        .get('/api/getVisitUrl', {})
        .then(res => {
          if (res.code == 200) {
            let url = query.pid ? res.data.url + 'register?pid=' + query.pid : res.data.url;
            console.log(url);
            if (process.env.NODE_ENV == 'development') {
              //开发环境下 取消跳转
              return;
            }
            window.open(url, '_self');
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    openDaoTime() {
      let that = this;
      if (!that.daoTime) {
        that.daoTime = setInterval(() => {
          that.getBalance();
        }, 4300);
      }
    },
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            that.clearUser();
            that.$dialog
              .alert({
                title: '认证失败',
                message: '您的账号登陆过期，请重新登陆',
              })
              .then(() => {
                that.$router.push({ path: '/login' });
              });
          }
        })
        .catch(res => {});
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          if (userInfo.isblack == 1) {
            //黑名单

            that.clearUser();
            that.showTost(0, '您已被设为黑名单，暂不能登录，请联系管理员！');

            return;
          }
          if (userInfo.status == 0) {
            //用户被禁用
            that.clearUser();
            that.showTost(0, '该用户已被禁用，请联系管理员！');

            return;
          }
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
        }
      });
    },
    clearUser() {
      let that = this;
      that.closeDaoTime();
      localStorage.clear();
      sessionStorage.clear();
      that.$store.commit('changUserInfo');
      that.$store.commit('changToken');
    },
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    // 打开游戏
    openGamePage(name, type, code) {
      let that = this;
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');
        return;
      }
      that.showTost(1, '跳转中...');

      that.showLoading();
      if (name == 'avia' || name == 'yb') {
        that.hideLoading();
        that.goNav(`/gamePage?name=${name}&type=${type}&code=${code}`);
        return;
      }
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          if (res.code != 200) {
            that.hideLoading();
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            window.location.href = res.data.url;
            setTimeout(() => {
              that.hideLoading();
            }, 1000);
          }
        })
        .catch(res => {
          let that = this;
          that.showTost(0, '网络连接超时，请重试!');
          that.hideLoading();
        });
    },
    // openGamePage(name, type, code) {
    //   let that = this;
    //   let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
    //   if (!token) {
    //     that.showTost(0, '请登录！');
    //     return;
    //   }
    //   that.goNav(`/gamePage?name=${name}&type=${type}&code=${code}`);
    // },
    goNav(url) {
      let that = this;
      if (url == '/wallet' || url == '/message?type=1' || url == '/wallet?type=0' || url == '/wallet?type=1' || url == '/transfer') {
        let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
        if (!token) {
          this.$router.push({ path: '/login' });

          return;
        }
      }
      if (url == this.$route.fullPath) {
        that.showTost(0, '已在当前页面！');
        return;
      }

      this.url = url;
      this.$router.push({ path: url });
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    openKefu() {
      let that = this;
      that.goNav(`/kefu`);
    },
    showTost(type, title) {
      let str = type ? 'success' : 'error';
      $('body').append(`
            <div class="alert_msg  alert_msgs active delay">
        <div class="alert_msg_pos">
            <div class="alert_msg_dialog">
                <div class="alert_msg_header">
                    <div id="alert_title">${title}</div>
                    <div>
                        <div id="alert_icon" class="ico-alert-${str}"></div>
                    </div>
                </div>
              
            </div>
        </div>
    </div>`);
      setTimeout('$(".alert_msgs").detach()', 2000);

      //     <div class="alert_msg  alert_msgs active delay">
      //     <div class="alert_msg_pos">
      //         <div class="alert_msg_dialog">
      //             <div class="alert_msg_header">
      //                 <div id="alert_title">成功</div>
      //                 <div>
      //                     <div id="alert_icon" class="ico-alert-success"></div>
      //                 </div>
      //             </div>
      //             <div class="alert_msg_body">
      //                 <div class="msg_show">钱包余额已更新!</div>
      //                 <div class="form_show"></div>
      //                 <div class="button_area"></div>
      //             </div>
      //         </div>
      //     </div>
      // </div>
    },
  },
  mounted() {
    let that = this;

    let vh = window.innerHeight; //* 0.01
    $('.main_area').css('height', `${vh - 130}px`);
    // // We listen to the resize event
    window.addEventListener('resize', () => {
      let vh = window.innerHeight; //* 0.01
      $('.main_area').css('height', `${vh - 130}px`);
    });
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>

<style>
.s11ss .el-pagination button:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background: none !important;
}
.badngs .van-dialog__header {
  
    color: #000!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue